import { useContext } from 'external/react'
import Accounting from 'context/accounting-context'
import useAuth from 'context/auth-context/hook'

export default function useAccounting() {
  const {user} = useAuth()
  const {state, update} = useContext(Accounting.Context)
  const {
    props: {params, query, navigation},
    payouts: {initialized: initializedPayouts, items: payouts},
    payoutsPaging,
    payout
  } = state

  return {
    state,
    update,
    params,
    query,
    navigation,
    payouts,
    initializedPayouts,
    payoutsPaging,
    payout
  }
}